import { ChatMessageModel, MessageStatusModel } from '@klant/conversational-connector/models/ChatMessage.model';
import { TypeModel } from '@klant/conversational-connector/models/Type.model';

import { inject, Injectable } from '@angular/core';

import { ConversationalChatVisibility } from '../../klant-conversational-connector.model';
import { ConversationService } from '../conversation/conversation.service';
import { WebsocketService } from '../wsservice/websocket.service';
import { ConversationalChatStore } from '../../../../signal-stores/conversational-chat-store/conversational-chat.store';

@Injectable({ providedIn: 'root' })
export class UnreadMessageService {
    private readonly chatStore = inject(ConversationalChatStore);
    private readonly conversationService = inject(ConversationService);
    private readonly webSocketService = inject(WebsocketService);

    public markMessagesAsRead(messages: ChatMessageModel[]): void {
        const receivedMessages = messages.filter((message) => this.shouldBeMarkedAsRead(message));

        if (this.conversationService.getChatVisibility() === ConversationalChatVisibility.MINIMIZED) {
            this.chatStore.addUnreadMessages(receivedMessages);
        } else {
            this.chatStore.clearUnreadMessages();
            this.webSocketService.markMessagesRead(receivedMessages);
        }

        this.conversationService.updateUnreadMessageCount(this.chatStore.unreadChatMessages().length);
    }

    private shouldBeMarkedAsRead(message: ChatMessageModel): boolean {
        const isOfCorrectMessageType = message.type === TypeModel.PLAIN_TEXT_MESSAGE || message.type === TypeModel.CHOICE_PROMPT_MESSAGE;
        const hasUpdatableStatus = message.messageStatus === MessageStatusModel.RECEIVED;

        return isOfCorrectMessageType && hasUpdatableStatus;
    }
}
